/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ContentDecision = zod.enum(['allow', 'review', 'block']);

export type ContentDecision = zod.input<typeof ContentDecision>;
export type ContentDecisionOutput = zod.output<typeof ContentDecision>;
